// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from 'lodash';
import * as constants from "../../constants";

const resetState = {
  isError: false,
  errors: [],
};
const initialState = {
  ...resetState,
  isLoading: false,
  documentationTree: [],
  newDocument: null,
  selectedViewDocument: {},
  isDocSaveSuccess: false,
  isDocDeleteSuccess: false,
  isUpdateTreeSuccess: false,
  documentErrors:[],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.ENTITY_GET_DOCUMENT_LIST_FETCH: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case constants.ENTITY_GET_DOCUMENT_LIST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentationTree: action.payload,
        isDocSaveSuccess: false,
        documentErrors: [],
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_GET_DOCUMENT_LIST_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentationTree: {},
        documentErrors: action.payload,
        isDocSaveSuccess: false,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_ADD_DOCUMENT: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        newDocument: action.payload,
        documentErrors: [],
        isDocSaveSuccess: false,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_GET_DOCUMENT_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        selectedViewDocument: action.payload,
        documentErrors: [],
        isDocSaveSuccess: false,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_GET_DOCUMENT_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        selectedViewDocument: {},
        documentErrors: action.payload,
        isDocSaveSuccess: false,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_DOCUMENT_SAVE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentErrors: [],
        isDocSaveSuccess: true,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
        selectedViewDocument: action.payload,
      };
    }
    case constants.ENTITY_DOCUMENT_SAVE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentErrors: action.payload,
        isDocSaveSuccess: false,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_DOCUMENT_DELETE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentErrors: [],
        isDocDeleteSuccess: true,
      };
    }
    case constants.ENTITY_DOCUMENT_DELETE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentErrors: action.payload,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_DOCUMENT_UPDATE_TREE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentErrors: [],
        isUpdateTreeSuccess: true,
      };
    }
    case constants.ENTITY_DOCUMENT_UPDATE_TREE_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        documentErrors: action.payload,
        isUpdateTreeSuccess: false,
      };
    }
    case constants.ENTITY_DOCUMENT_RESET_NOTIFICATION: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        isDocSaveSuccess: false,
        isDocDeleteSuccess: false,
        isUpdateTreeSuccess: false,
      };
    }
    default:
      return state;
  }
}

export const getDocumentationTree = (state) => get(state, 'documentation.documentationTree.itemData', []);
export const getNewDocument = state => get(state, 'documentation.newDocument', null);
export const getSelectedViewDocument = state => get(state, 'documentation.selectedViewDocument', {});
export const getIsDocSaveSuccess = state => get(state, 'documentation.isDocSaveSuccess', false);
export const getIsDocDeleteSuccess = state => get(state, 'documentation.isDocDeleteSuccess', false);
export const getIsUpdateTreeSuccess = state => get(state, 'documentation.isUpdateTreeSuccess', false);
export const getDocumentErrors = state => get(state, 'documentation.documentErrors', []);
export const getIsLoading = state => get(state, 'documentation.isLoading', false);
